import styles from './index.module.scss';
import {Menu} from 'antd';
import classNames from 'classnames';
import {MenuFoldOutlined, MenuUnfoldOutlined} from '@ant-design/icons';
import React, {useMemo, useState} from 'react';
import {ItemType} from 'antd/es/menu/hooks/useItems';
import {NavLink} from 'react-router-dom';
import {AppMenuItem} from '../../../../../MainMenu';

interface AsideProps {
    menuItems: AppMenuItem[];
}

export function Aside({menuItems}: AsideProps) {
    const [collapsed, setCollapsed] = useState(false);

    const defaultOpenKeys = useMemo<string[]>(
        () => menuItems.map(item => item.handle.key || ''),
        [menuItems],
    );

    //data：要遍历的数据， target：查找目标， result用于装查找结果的数组
    function findParent(data: AppMenuItem[], target: string, result: any[]) {
        for (let item of data) {
            if (item.handle?.label === target) {
                //将查找到的目标数据加入结果数组中
                //可根据需求unshift(item.id)或unshift(item)
                result.unshift(item.path);
                return true;
            }
            if (item.children && item.children.length > 0) {
                //根据查找到的结果往上找父级节点
                let isFind = findParent(item.children, target, result);
                if (isFind) {
                    result.unshift(item.path);
                    return true;
                }
            }
        }
        //走到这说明没找到目标
        return false;
    }

    // 所有菜单
    function getMenu(data: AppMenuItem[], parentKey?: string): ItemType[] {
        return data
            .filter(item => !!item?.handle?.showNav)
            .map(item => {
                let result: string[] = [];
                findParent(menuItems, item.handle?.label!, result);

                if (item.handle?.isLast) {
                    item.children = undefined;
                }
                return {
                    key:
                        item.handle.key ||
                        `${parentKey}-${item?.handle?.label}`,
                    label: item.path ? (
                        <NavLink
                            to={result.join('/')}
                            style={{
                                color: '#333',
                            }}
                            className={({isActive}) =>
                                classNames({[styles.activeLink]: isActive})
                            }>
                            {item?.handle?.label}
                        </NavLink>
                    ) : (
                        item?.handle?.label
                    ),
                    icon: item?.handle?.icon,
                    children: item.children
                        ? getMenu(item.children, item.path)
                        : null,
                };
            });
    }

    return (
        <div
            className={classNames(styles.root, {
                [styles.collapse]: collapsed,
            })}>
            <div className={styles.menuWrapper}>
                <Menu
                    mode="inline"
                    className={styles.menu}
                    selectable={false}
                    defaultOpenKeys={defaultOpenKeys}
                    inlineCollapsed={collapsed}
                    items={getMenu(menuItems)}
                />
            </div>

            <div className={styles.collapseWrapper}>
                <Menu
                    selectable={false}
                    mode="inline"
                    inlineCollapsed={collapsed}
                    onClick={() => setCollapsed(!collapsed)}
                    items={[
                        {key: 'divider', type: 'divider'},
                        {
                            key: 'button',
                            icon: React.createElement(
                                collapsed
                                    ? MenuUnfoldOutlined
                                    : MenuFoldOutlined,
                            ),
                        },
                    ]}
                />
            </div>
        </div>
    );
}
